exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inputIsentoChecked[data-v-41173a37]{background-color:#ede56a}", ""]);

// exports
